<!-- New Message Form -->
@if (showNewMessageForm) {
<div class="">
	<h4 class="!!text-sm font-medium text-gray-800 mb-5">Nouveau message</h4>

	<form (ngSubmit)="submitNewMessage()" class="space-y-4">
		<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
			<div>
				<label class="block text-[12px] font-medium text-gray-700 mb-1">Type de destinataire</label>
				<select [(ngModel)]="newMessageForm.destinaryType" name="destinaryType"
					class="!text-sm w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent">
					<option value="INSURER">Assureur/IPM</option>
				</select>
			</div>
		</div>

		<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
			<div>
				<label class="block text-[12px] font-medium text-gray-700 mb-1">Sélectionnez un type de message</label>
				<select [(ngModel)]="newMessageForm.messageType" name="messageType" (ngModelChange)="onMessageTypeChange()"
					class="!text-sm w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
					[disabled]="messageTypesLoading">
					@if (messageTypesLoading) {
					<option value="">Chargement...</option>
					} @else {
					<option value="">Choisir un type de message</option>
					@for (messageType of messageTypes; track messageType.type) {
					<option [value]="messageType.type">{{ messageType.label | uppercase }}</option>
					}
					}
				</select>
			</div>
		</div>

		<!-- CARE_REQUEST || QUOTE || REFUND_REQUEST -->
		@if (newMessageForm.messageType === 'CARE_REQUEST' || newMessageForm.messageType === 'QUOTE' || newMessageForm.messageType === 'REFUND_REQUEST') {
		<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
			<div>
				<label class="block text-[12px] font-medium text-gray-700 mb-1">Sélectionnez un bénéficiaire</label>
				<select [(ngModel)]="newMessageForm.beneficiaryPasspport" name="beneficiaryPasspport"
					class="!text-sm w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent">
					<option value="">Choisir un bénéficiaire</option>
					@for (beneficiary of beneficiaries; track beneficiary.passportNumber) {
					<option [value]="beneficiary.passportNumber">{{ beneficiary.fullname }}</option>
					}
				</select>
			</div>
			<div>
				@if (insurerExternalId && contract?.organism?.externalId) {
				<app-provider-autocomplete label="Recherchez un prestataire"
					placeholder="Rechercher un médecin, pharmacie, laboratoire..." [required]="true"
					[insurerExternalId]="contract?.organism?.externalId"
					[messageType]="newMessageForm.messageType"
					(providerSelected)="onProviderSelected($event)"
					(validationRequested)="onValidationRequested($event)"
					(providerTypeChanged)="onProviderTypeChanged($event)"></app-provider-autocomplete>
				}
			</div>
		</div>
		<div class="mt-4">
			<label class="block !text-sm font-medium text-gray-700 mb-2">Ecrivez votre message ci-dessous</label>
			<textarea [(ngModel)]="newMessageForm.content" name="content" rows="6" placeholder="Décrivez votre demande..."
				class="!text-sm w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent resize-none"></textarea>
		</div>

		<!-- Section d'attachement de fichier pour CARE_REQUEST || QUOTE || REFUND_REQUEST -->
		@if (newMessageForm.beneficiaryPasspport) {
		<div class="mt-4">
			<label class="block !text-sm font-medium text-gray-700 mb-2">Joindre un fichier (optionnel)</label>
			<div class="relative">
				<input type="file" name="attachment" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" (change)="onFileSelected($event)"
					multiple class="hidden" #fileInput />
				<div
					class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary hover:bg-gray-50 transition-colors cursor-pointer"
					(click)="fileInput.click()">
					<div class="flex flex-col items-center">
						<svg class="w-8 h-8 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
						</svg>
						<p class="!text-sm text-gray-600 mb-1">Cliquez pour sélectionner un fichier</p>
						<p class="text-xs text-gray-500">PDF, DOC, DOCX, JPG, PNG - Max 5MB par fichier, 10MB au total</p>
					</div>
				</div>
				@if (uploadedFiles.length > 0) {
				<div class="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
					@for (fileTracker of uploadedFiles; track fileTracker.id) {
					<div class="relative" [class.opacity-50]="fileTracker.isUploading || fileTracker.error">
						@if (isImageFile(fileTracker.file.name)) {
							<!-- Preview d'image -->
							<div class="relative group border border-gray-200 rounded-lg overflow-hidden bg-white">
								<img [src]="fileTracker.previewUrl || fileTracker.uploadedUrl" [alt]="fileTracker.file.name"
									class="w-full aspect-square object-cover object-center">
								<!-- Progress bar overlay -->
								@if (fileTracker.isUploading) {
								<div class="absolute inset-0 bg-black/20 flex items-center justify-center">
									<div class="w-full px-3">
										<div class="w-full bg-gray-200 rounded-full h-2">
											<div class="bg-primary h-2 rounded-full transition-all duration-300" 
												[style.width.%]="fileTracker.progress"></div>
										</div>
										<p class="text-xs text-white mt-1 text-center">{{ fileTracker.progress }}%</p>
									</div>
								</div>
								}
								<!-- Error message -->
								@if (fileTracker.error) {
								<div class="absolute inset-0 bg-red-500/20 flex items-center justify-center p-2">
									<p class="text-xs text-red-700 text-center">{{ fileTracker.error }}</p>
								</div>
								}
								<!-- Remove button -->
								<button type="button" (click)="clearSelectedFile(fileTracker.id)" 
									class="absolute top-2 right-2 p-1 bg-white/90 rounded-full hover:bg-white transition-colors shadow-sm">
									<lucide-icon [img]="X" class="w-4 h-4 text-gray-700"></lucide-icon>
								</button>
								<!-- Uploaded badge -->
								@if (fileTracker.isUploaded && !fileTracker.isUploading) {
								<div class="absolute bottom-2 left-2 px-2 py-1 bg-green-500 text-white text-xs rounded-full">
									✓ Uploadé
								</div>
								}
							</div>
						} @else {
							<!-- Card pour documents -->
							<div class="bg-white border border-gray-200 rounded-lg p-3 flex items-start gap-3">
								<div class="shrink-0 mt-1">
									<lucide-icon [img]="getFileIcon(fileTracker.file.name)" class="w-5 h-5 text-gray-500"></lucide-icon>
								</div>
								<div class="flex-1 min-w-0">
									<p class="text-sm font-medium text-gray-900 truncate" [title]="fileTracker.file.name">
										{{ fileTracker.file.name }}
									</p>
									<p class="text-xs text-gray-500 mt-0.5">
										{{ formatFileSize(fileTracker.file.size) }}
									</p>
									<!-- Progress bar -->
									@if (fileTracker.isUploading) {
									<div class="mt-2">
										<div class="w-full bg-gray-200 rounded-full h-1.5">
											<div class="bg-primary h-1.5 rounded-full transition-all duration-300" 
												[style.width.%]="fileTracker.progress"></div>
										</div>
										<p class="text-xs text-gray-600 mt-1">{{ fileTracker.progress }}%</p>
									</div>
									}
									<!-- Error message -->
									@if (fileTracker.error) {
									<p class="text-xs text-red-600 mt-1">{{ fileTracker.error }}</p>
									}
									<!-- Uploaded badge -->
									@if (fileTracker.isUploaded && !fileTracker.isUploading) {
									<p class="text-xs text-green-600 mt-1">✓ Uploadé</p>
									}
								</div>
								<!-- Remove button -->
								<button type="button" (click)="clearSelectedFile(fileTracker.id)" 
									class="shrink-0 text-gray-400 hover:text-gray-600 transition-colors">
							<lucide-icon [img]="X" class="w-4 h-4"></lucide-icon>
						</button>
					</div>
					}
					</div>
					}
				</div>
				}
			</div>
		</div>
		}
		}

		<!-- INSURANCE_IDENTIFICATION_NUM_MAJ -->
		@if (newMessageForm.messageType === 'INSURANCE_IDENTIFICATION_NUM_MAJ') {
		<div class="mt-4">
			<label class="block !text-sm font-medium text-gray-700 mb-2">Numéro de téléphone</label>
			<angular-phone-number-input [(ngModel)]="newMessageForm.content" name="content"
				[preferredCountries]="preferredCountries" [defaultCountry]="'SN'" [border]="true" class="w-full">
			</angular-phone-number-input>
			<p class="text-xs text-gray-500 mt-1">Seuls les numéros du Sénégal (+221) et du Gabon (+241) sont acceptés</p>
		</div>
		}

		<!-- IDENTIFICATION_PHOTO_MAJ -->
		@if (newMessageForm.messageType === 'IDENTIFICATION_PHOTO_MAJ') {
		<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
			<div>
				<label class="block text-[12px] font-medium text-gray-700 mb-1">Sélectionnez un bénéficiaire</label>
				<select [(ngModel)]="newMessageForm.beneficiaryPasspport" name="beneficiaryPasspport"
					class="!text-sm w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent">
					<option value="">Choisir un bénéficiaire</option>
					@for (beneficiary of beneficiaries; track beneficiary.passportNumber) {
					<option [value]="beneficiary.passportNumber">{{ beneficiary.fullname }}</option>
					}
				</select>
			</div>
			@if (newMessageForm.beneficiaryPasspport) {
			<div>
				<label class="block !text-sm font-medium text-gray-700 mb-2">Photo d'identité</label>
				<div class="relative">
					<input type="file" name="photo" accept="image/*" (change)="onFileSelected($event)" class="hidden"
						#fileInput />
					<div
						class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary hover:bg-gray-50 transition-colors cursor-pointer"
						(click)="fileInput.click()">
						<div class="flex flex-col items-center">
							<svg class="w-8 h-8 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
									d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
							</svg>
							<p class="!text-sm text-gray-600 mb-1">Cliquez pour sélectionner une photo</p>
							<p class="text-xs text-gray-500">PNG, JPG, JPEG jusqu'à 5MB</p>
						</div>
					</div>
					@if (uploadedFiles.length > 0) {
					<div class="mt-4">
						@for (fileTracker of uploadedFiles; track fileTracker.id) {
						<div class="relative" [class.opacity-50]="fileTracker.isUploading || fileTracker.error">
							<!-- Preview d'image pour photo d'identité -->
							<div class="relative group border border-gray-200 rounded-lg overflow-hidden bg-white">
								<img [src]="fileTracker.previewUrl || fileTracker.uploadedUrl" [alt]="fileTracker.file.name"
									class="!w-16 !h-16 aspect-square object-cover object-center">
								<!-- Progress bar overlay -->
								@if (fileTracker.isUploading) {
								<div class="absolute inset-0 bg-black/20 flex items-center justify-center">
									<div class="w-full px-4">
										<div class="w-full bg-gray-200 rounded-full h-2">
											<div class="bg-primary h-2 rounded-full transition-all duration-300" 
												[style.width.%]="fileTracker.progress"></div>
										</div>
										<p class="text-xs text-white mt-2 text-center">{{ fileTracker.progress }}%</p>
									</div>
								</div>
								}
								<!-- Error message -->
								@if (fileTracker.error) {
								<div class="absolute inset-0 bg-red-500/20 flex items-center justify-center p-2">
									<p class="text-xs text-red-700 text-center">{{ fileTracker.error }}</p>
								</div>
								}
								<!-- Remove button -->
								<button type="button" (click)="clearSelectedFile(fileTracker.id)" 
									class="absolute top-2 right-2 p-1 bg-white/90 rounded-full hover:bg-white transition-colors shadow-sm">
									<lucide-icon [img]="X" class="w-4 h-4 text-gray-700"></lucide-icon>
							</button>
								<!-- Uploaded badge -->
								@if (fileTracker.isUploaded && !fileTracker.isUploading) {
								<div class="absolute bottom-2 left-2 px-2 py-1 bg-green-500 text-white text-xs rounded-full">
									✓ Uploadé
								</div>
								}
							</div>
						</div>
						}
					</div>
					}
				</div>
			</div>
			}
		</div>
		}

		<!-- QUESTION -->
		@if (newMessageForm.messageType === 'QUESTION') {
		<div class="mt-4">
			<label class="block !text-sm font-medium text-gray-700 mb-2">Votre question</label>
			<textarea [(ngModel)]="newMessageForm.content" name="content" rows="6" placeholder="Posez votre question..."
				class="!text-sm w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent resize-none"></textarea>
		</div>

		<!-- Section d'attachement de fichier pour QUESTION -->
		@if (newMessageForm.beneficiaryPasspport || currentUser?.passportNumber) {
		<div class="mt-4">
			<label class="block !text-sm font-medium text-gray-700 mb-2">Joindre un fichier (optionnel)</label>
			<div class="relative">
				<input type="file" name="attachment" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" (change)="onFileSelected($event)"
					multiple class="hidden" #fileInput />
				<div
					class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-primary hover:bg-gray-50 transition-colors cursor-pointer"
					(click)="fileInput.click()">
					<div class="flex flex-col items-center">
						<svg class="w-8 h-8 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
						</svg>
						<p class="!text-sm text-gray-600 mb-1">Cliquez pour sélectionner un fichier</p>
						<p class="text-xs text-gray-500">PDF, DOC, DOCX, JPG, PNG - Max 5MB par fichier, 10MB au total</p>
					</div>
				</div>
				@if (uploadedFiles.length > 0) {
				<div class="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
					@for (fileTracker of uploadedFiles; track fileTracker.id) {
					<div class="relative" [class.opacity-50]="fileTracker.isUploading || fileTracker.error">
						@if (isImageFile(fileTracker.file.name)) {
							<!-- Preview d'image -->
							<div class="relative group border border-gray-200 rounded-lg overflow-hidden bg-white">
								<img [src]="fileTracker.previewUrl || fileTracker.uploadedUrl" [alt]="fileTracker.file.name"
									class="w-full aspect-square object-cover object-center">
								<!-- Progress bar overlay -->
								@if (fileTracker.isUploading) {
								<div class="absolute inset-0 bg-black/20 flex items-center justify-center">
									<div class="w-full px-3">
										<div class="w-full bg-gray-200 rounded-full h-2">
											<div class="bg-primary h-2 rounded-full transition-all duration-300" 
												[style.width.%]="fileTracker.progress"></div>
										</div>
										<p class="text-xs text-white mt-1 text-center">{{ fileTracker.progress }}%</p>
									</div>
								</div>
								}
								<!-- Error message -->
								@if (fileTracker.error) {
								<div class="absolute inset-0 bg-red-500/20 flex items-center justify-center p-2">
									<p class="text-xs text-red-700 text-center">{{ fileTracker.error }}</p>
								</div>
								}
								<!-- Remove button -->
								<button type="button" (click)="clearSelectedFile(fileTracker.id)" 
									class="absolute top-2 right-2 p-1 bg-white/90 rounded-full hover:bg-white transition-colors shadow-sm">
									<lucide-icon [img]="X" class="w-4 h-4 text-gray-700"></lucide-icon>
								</button>
								<!-- Uploaded badge -->
								@if (fileTracker.isUploaded && !fileTracker.isUploading) {
								<div class="absolute bottom-2 left-2 px-2 py-1 bg-green-500 text-white text-xs rounded-full">
									✓ Uploadé
								</div>
								}
							</div>
						} @else {
							<!-- Card pour documents -->
							<div class="bg-white border border-gray-200 rounded-lg p-3 flex items-start gap-3">
								<div class="shrink-0 mt-1">
									<lucide-icon [img]="getFileIcon(fileTracker.file.name)" class="w-5 h-5 text-gray-500"></lucide-icon>
								</div>
								<div class="flex-1 min-w-0">
									<p class="text-sm font-medium text-gray-900 truncate" [title]="fileTracker.file.name">
										{{ fileTracker.file.name }}
									</p>
									<p class="text-xs text-gray-500 mt-0.5">
										{{ formatFileSize(fileTracker.file.size) }}
									</p>
									<!-- Progress bar -->
									@if (fileTracker.isUploading) {
									<div class="mt-2">
										<div class="w-full bg-gray-200 rounded-full h-1.5">
											<div class="bg-primary h-1.5 rounded-full transition-all duration-300" 
												[style.width.%]="fileTracker.progress"></div>
										</div>
										<p class="text-xs text-gray-600 mt-1">{{ fileTracker.progress }}%</p>
									</div>
									}
									<!-- Error message -->
									@if (fileTracker.error) {
									<p class="text-xs text-red-600 mt-1">{{ fileTracker.error }}</p>
									}
									<!-- Uploaded badge -->
									@if (fileTracker.isUploaded && !fileTracker.isUploading) {
									<p class="text-xs text-green-600 mt-1">✓ Uploadé</p>
									}
								</div>
								<!-- Remove button -->
								<button type="button" (click)="clearSelectedFile(fileTracker.id)" 
									class="shrink-0 text-gray-400 hover:text-gray-600 transition-colors">
							<lucide-icon [img]="X" class="w-4 h-4"></lucide-icon>
						</button>
					</div>
					}
					</div>
					}
				</div>
				}
			</div>
		</div>
		}
		}

		<!-- Form Actions -->
		<div class="flex justify-end gap-3 pt-4">
			<button type="button" (click)="cancelNewMessage()"
				class="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
				Annuler
			</button>
			<button type="submit" [disabled]="!isFormValid() || sendingMessage"
				class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2">
				@if (!sendingMessage) {
				<span>Envoyer le message</span>
				} @else {
				<div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
				<span>Envoi en cours...</span>
				}
			</button>
		</div>
	</form>
</div>

<!-- Modal de validation pour prestataire non conventionné -->
@if (showValidationModal) {
<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
	<div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
		<div class="flex items-center justify-between mb-4">
			<h3 class="text-lg font-medium text-gray-900">Confirmer l'ajout d'un nouveau prestataire non conventionné</h3>
			<button type="button" (click)="closeValidationModal()" class="text-gray-400 hover:text-gray-600">
				<lucide-icon [img]="X" class="w-5 h-5"></lucide-icon>
			</button>
		</div>

		<div class="space-y-4">
			<div>
				<label class="block text-sm font-medium text-gray-700 mb-2">Nom du prestataire <span class="text-red-500">*</span></label>
				<input type="text" [(ngModel)]="validationData.providerName" 
					[class]="'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent ' + (validationErrors.providerName ? 'border-red-300 bg-red-50' : 'border-gray-300')">
				@if (validationErrors.providerName) {
				<p class="text-red-500 text-xs mt-1">{{ validationErrors.providerName }}</p>
				}
			</div>

			<div>
				<label class="block text-sm font-medium text-gray-700 mb-2">Type de prestataire <span class="text-red-500">*</span></label>
				<select [(ngModel)]="validationData.providerType" 
					[class]="'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent ' + (validationErrors.providerType ? 'border-red-300 bg-red-50' : 'border-gray-300')">
					<option value="">Sélectionnez un type</option>
					<option value="PHARMACY">Pharmacie</option>
					<option value="DOCTOR">Médecin/CABINET MÉDICAL</option>
					<option value="HOSPITAL">Hôpital</option>
				</select>
				@if (validationErrors.providerType) {
				<p class="text-red-500 text-xs mt-1">{{ validationErrors.providerType }}</p>
				}
			</div>
		</div>

		<div class="flex justify-end gap-3 mt-6">
			<button type="button" (click)="closeValidationModal()" 
				class="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
				Annuler
			</button>
			<button type="button" (click)="validateProvider()" 
				[disabled]="!validationData.providerName.trim() || !validationData.providerType || validatingProvider"
				class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2">
				@if (!validatingProvider) {
				<span>Confirmer et envoyer</span>
				} @else {
				<div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
				<span>Envoi en cours...</span>
				}
			</button>
		</div>
	</div>
</div>
}
} @else {
<div class="flex gap-3 h-full max-h-[600px] messages-container">
	@if (discussions.length > 0) {
	<div class="w-[250px] flex flex-col h-full">
		<!-- Conteneur des discussions avec scroll -->
		<div class="flex-1 overflow-y-auto space-y-2 pr-2 discussions-scroll">
			@for (discussion of discussions; track discussion.id) {
			<div class="bg-slate-50 p-2 rounded hover:bg-slate-100 cursor-pointer" (click)="selectDiscussion(discussion.id)"
				[class.!bg-slate-200]="discussion.id === selectedDiscussionId">
				<span class="text-xs text-gray-500">{{ discussion.insurerName }}</span>
				<div class="flex items-center gap-2">
					<span class="text-xs text-gray-500">{{ discussion.title }}</span>
					@if (refreshing) {
					<div class="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400 ml-auto"></div>
					}
				</div>
			</div>
			}
		</div>

		<!-- Bouton Voir plus (fixé en bas) -->
		@if (hasMoreDiscussions) {
		<div class="pt-2 flex-shrink-0">
			<button (click)="loadMoreDiscussions()" [disabled]="loadingMore"
				class="w-full px-3 py-2 text-xs text-primary bg-primary/10 rounded-lg hover:bg-primary/20 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2">
				@if (!loadingMore) {
				<span>Voir plus</span>
				} @else {
				<div class="animate-spin rounded-full h-3 w-3 border-b-2 border-primary"></div>
				<span>Chargement...</span>
				}
			</button>
		</div>
		}
	</div>
	}
	<div class="flex-grow"><!-- Messages Container -->
		<div class="bg-gray-50 rounded-lg p-4 h-full overflow-y-auto mb-4">
			@if (loading) {
			<div class="flex items-center justify-center h-full">
				<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
				<span class="ml-3 text-gray-600">Chargement des messages...</span>
			</div>
			} @else if (discussions.length === 0) {
			<div class="flex flex-col items-center justify-center h-full text-gray-500">
				<lucide-icon [img]="MessageCircle" class="w-12 h-12 mb-4 text-gray-300"></lucide-icon>
				<p class="text-center">Aucun message pour le moment</p>
				<p class="!text-sm text-center mt-2">Commencez une conversation avec votre assureur</p>
			</div>
			} @else if (selectedDiscussionId) {
			<div class="flex flex-col h-full justify-between">
				<div>
					<!-- content current discussion -->
					@if (selectedDiscussion) {
					<app-message-responses [discussionId]="selectedDiscussion.id" [messageId]="selectedDiscussion.id">
					</app-message-responses>
					}
				</div>
				<div>
					@if (documents.length > 0) {
					<div class="flex flex-wrap gap-3 mb-4">
						<div class="flex flex-wrap gap-3">
							@for (doc of documents; track doc.url) {
								@if (isImageFile(doc.filename)) {
									<!-- Afficher l'image directement -->
									<div class="relative group h-[60px]">
										<img [src]="doc.url" [alt]="doc.filename" 
											class="h-full w-auto rounded-lg object-cover cursor-pointer border border-gray-200 hover:opacity-90 transition-opacity"
											(click)="openDocument(doc)"
											onerror="this.onerror=null; this.src=''">
										<div class="absolute inset-0 bg-black/0 group-hover:bg-black/10 rounded-lg transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100 pointer-events-none">
											<div class="p-2 bg-white/90 rounded-full">
												<lucide-icon [img]="Eye" class="w-4 h-4 text-gray-700"></lucide-icon>
											</div>
										</div>
									</div>
								} @else {
									<!-- Afficher la carte pour les fichiers non-image -->
									<div class="bg-white border border-gray-200 rounded-lg p-3 flex items-center gap-3 min-w-[200px] max-w-[250px] h-[60px]">
										<div class="shrink-0">
											<lucide-icon [img]="getFileIcon(doc.filename)" class="w-5 h-5 text-gray-500"></lucide-icon>
										</div>
										<div class="flex-1 min-w-0">
											<p class="text-sm font-medium text-gray-900 truncate" [title]="doc.filename">
												{{ doc.filename }}
											</p>
											<p class="text-xs text-gray-500 mt-0.5">
												{{ formatFileSize(doc.sizeBytes) }}
											</p>
										</div>
										<button (click)="openDocument(doc)" 
											class="shrink-0 text-gray-400 hover:text-primary transition-colors"
											title="Ouvrir dans un nouvel onglet">
											<lucide-icon [img]="Eye" class="w-4 h-4"></lucide-icon>
										</button>
									</div>
								}
							}
						</div>
					</div>
					}
					<div class="flex gap-2">
						<div class="flex-1 relative">
							<input type="text" [(ngModel)]="newMessage" placeholder="Tapez votre message..."
								class="!text-sm w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent">
							<!-- <button class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
								<lucide-icon [img]="Paperclip" class="w-5 h-5"></lucide-icon>
							</button> -->
						</div>
						<button (click)="sendMessage()" [disabled]="!newMessage.trim() || sendingMessage"
							class="px-4 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
							@if (!sendingMessage) {
							<lucide-icon [img]="Send" class="w-4 h-4"></lucide-icon>
							<span class="!text-sm">Envoyer</span>
							} @else {
							<div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
							<span class="!text-sm">Envoi...</span>
							}
						</button>
					</div>
				</div>
			</div>
			}
		</div>
	</div>
</div>
}